import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

const axiosInstance = axios.create()

//요청 가로채기
axiosInstance.interceptors.request.use(
  //요청 보내기전 수행
  async function (config) {
    const recoilValue = localStorage.getItem('recoil-persist')
    // console.log('recoilValue = ', recoilValue)
    if (recoilValue !== null) {
      const parserdRecoilValue = JSON.parse(recoilValue)
      // console.log('tokenInfo = ', parserdRecoilValue?.token)
      if (
        parserdRecoilValue !== null &&
        parserdRecoilValue?.token?.accessToken &&
        parserdRecoilValue?.token?.refreshToken
      ) {
        // config.headers['x-dy-accesstoken'] =
        //   parserdRecoilValue.token.accessToken
        // config.headers['x-dy-refreshToken'] =
        //   parserdRecoilValue.token.refreshToken
      }
    }
    return config
  },
  //오류 요청
  function (err) {
    return Promise.reject(err)
  },
)

/**
 * 커뮤니티 유저 조회
 * @returns
 */
export const getCommunityUserList = async (communityCategoryId, page, size) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/admin/community/participants`,
    {
      params: {
        communityCategoryId,
        page,
        size,
      },
    },
  )
  return res.data
}

/**
 * 커뮤니티 카테고리 전제 조회
 */
export const getCommunityCategoryList = async (params) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/admin/community/categories`,
  )
  return res.data
}

/**
 * 커뮤니티 유저 등록
 */
export const registerCommunityParticipant = async (
  communityCategoryId,
  phone,
) => {
  const res = await axios.post(`${SUGARCOACH_BASE_URL}/admin/community/user`, {
    communityCategoryId,
    phone,
  })
  return res.data
}

/**
 * 유저 삭제
 */

export const deleteCommunityUser = async (id) => {
  const res = await axios.delete(
    `${SUGARCOACH_BASE_URL}/admin/community/participant/${id}`,
  )
  return res.data
}

/**
 * 커뮤니티 테이블 조회
 */

export const getCommunityList = async (page, size) => {
  const res = await axios.get(`${SUGARCOACH_BASE_URL}/admin/community/list`, {
    params: {
      page,
      size,
    },
  })
  return res.data
}

/**
 * 커뮤니티 댓글 조회
 */

export const getCommunityCommentList = async (communityId, page, size) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/admin/community/${communityId}/comments`,
    {
      params: {
        communityId,
        page,
        size,
      },
    },
  )
  return res.data
}

/**
 * 관리자의 유저 댓글 삭제
 */
export const deleteCommunityComment = async (commentId) => {
  const res = await axios.delete(
    `${SUGARCOACH_BASE_URL}/admin/community/${commentId}/comments`,
  )
  return res.data
}
/**
 * 관리자의 본인 댓글 삭제
 */
export const deleteCommunityReply = async (replyId) => {
  const res = await axios.delete(
    `${SUGARCOACH_BASE_URL}/admin/community/${replyId}/reply`,
  )
  return res.data
}

/**
 * 커뮤니티 댓글 등록
 */

export const addCommunityReply = async (params) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/admin/community/reply`,
    params,
  )
  return res.data
}

/**
 * 커뮤니티 정보 조회
 */

export const getCommunityInfo = async (communityId) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/admin/community/${communityId}/detail-info`,
  )
  return res.data
}

/**
 * 커뮤니티 안내 문구 수정
 */

export const updateCommunityInfo = async (communityId, content) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/admin/community/${communityId}/edit-info`,
    { content },
  )
  return res.data
}

/**
 * 가이드북 조회
 */

export const getCommunityGuidebook = async (categoryId) => {
  const res = await axios.get(`${SUGARCOACH_BASE_URL}/admin/community/guide`, {
    params: {
      categoryId,
    },
  })
  return res.data
}

/**
 * 가이드북 수정
 */

export const updateCommunityGuidebook = async (guideId, params) => {
  const res = await axios.patch(
    `${SUGARCOACH_BASE_URL}/admin/community/${guideId}/guide`,
    params,
  )
  return res.data
}

/**
 * 가이드북 등록
 */

export const addCommunityGuidebook = async (params) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/admin/community/guide`,
    params,
  )
  return res.data
}

/**
 * 가이드북 삭제
 */

export const deleteCommunityGuidebook = async (guideId) => {
  const res = await axios.delete(
    `${SUGARCOACH_BASE_URL}/admin/community/${guideId}/guide`,
  )
  return res.data
}

/**
 * 스캔권 발급
 */
export const issueUserTicket = async (params) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/v2/admin/program-ticket-to-user-by-type/issue`,
    params,
  )
  return res.data
}

/**
 * 유저 보유 스캔권 목록
 */
export const getUserTicketList = async (userId, page, size) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/admin/community/participant/${userId}/program-tickets`,
    {
      params: {
        userId,
        page,
        size,
      },
    },
  )
  return res.data
}
